import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import NormalValidation from "../Forms/FormValidation/units/NormalValidation";

const UnitsCreate = () => {
  document.title = "Novo Orgão de Estrutura - Khozi";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Orgãos de Estrutura"
            breadcrumbItem="Novo Orgão de Estrutura"
          />
          <NormalValidation />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default UnitsCreate;
